import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookie from 'js-cookie'

export type CurrentUser = {
  message?: string
  authToken?: string
  data?: {
    email?: string
    id?: number | string
    roles?: string
  }
}

type State = {
  currentUser: CurrentUser
  setCurrentUser?: any
  removeCurrentUser?(): void
}

const useCurrentUserStore = create<State>(
  persist(
    (set) => ({
      currentUser: {},
      setCurrentUser: (currentUser) => {
        setUserToken(currentUser.authToken)
        return set({ currentUser })
      },
      removeCurrentUser: () => {
        removeUserToken()
        return set({ currentUser: {} })
      },
    }),
    {
      name: 'wbs-current-user',
    }
  )
)

export default useCurrentUserStore

export const setUserToken = (token) => Cookie.set('userToken', token)
export const getUserToken = (): string => Cookie.get('userToken')
export const removeUserToken = () => Cookie.remove('userToken')
